import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { FixtureTable } from "components/Shared/FixtureTable";
import { PageTitle } from "components/Shared/PageTitle";
import { useFetchFixtures } from "hooks/useFixturesApi";
import { useFetchSeason } from "hooks/useSeasonsApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useFixturesColumns } from "./hooks/useFixturesColumns";

export const FixturesPage = () => {
  const { customerId, sport, organizationId, entityId: entityIdFromParams, seasonId: seasonIdFromParams } = useParams();
  const entityId = entityIdFromParams || "undefined";
  const seasonId = seasonIdFromParams || "undefined";
  const { formatMessage } = useIntl();
  const { isLoading: isSeasonLoading, data: seasonResponse } = useFetchSeason({
    entityId,
    seasonId,
  });
  const season = seasonResponse?.data?.[0];
  const { isLoading: isFixturesLoading, data: fixturesResponse } = useFetchFixtures({ entityId, seasonId });
  const fixtures = fixturesResponse?.data || [];
  const isLoading = isSeasonLoading || isFixturesLoading;
  const columns = useFixturesColumns({ fixtures });

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle
          isLoading={isLoading}
          title={formatMessage({ id: "fixturesPage.title" }, { seasonName: season?.nameLocal })}
        />
        <BackToButton
          to={`/${customerId}/${sport}/${organizationId}/entities/${entityId}`}
          btnText={formatMessage({ id: "back.to.entity" })}
        />
      </Row>
      <Divider />
      <FixtureTable isLoading={isLoading} fixtures={fixtures} columns={columns} />
    </>
  );
};
